export const CHANNEL_VIDEO_LIST_VALUES = {
  EXPAND_ON_CLICK: 1,
  ALWAYS_SHOW: 2,
  NEVER_SHOW: 3,
};



// WEBPACK FOOTER //
// ./~/wix-vod-shared/src/app-settings/constants/channel-video-list-values.js